<script>
    import { push } from "svelte-spa-router";
    import ContentSection from "../../../../common/ContentSection.svelte";
    import GeneralLayout from "../../../../common/GeneralLayout.svelte";
    import HeaderBar from "../../../../components/header/HeaderBar.svelte";
    import { _ } from "svelte-i18n";
    import { getEntities } from "../../../../api-client";
    import LoadingSquare from "../../../../common/LoadingSquare.svelte";

    $: podcasts = getEntities("podcast");
</script>

<div class="display-small">
    <HeaderBar title={$_("podcasts_title")} />
</div>
<GeneralLayout>
    <div slot="firstSegment">
        <div class="display-big">
            <HeaderBar hideSeperator />
        </div>
        <div class="headline-l title">{$_("podcasts_title")}</div>
    </div>
    <div slot="secondSegment">
        {#await podcasts}
            <LoadingSquare />
        {:then podcasts}
            {#each podcasts as podcast, index}
                <div
                    class="content-wrapper"
                    style="cursor: pointer"
                    on:click={() => push(`/podcasts/${podcast.id}`)}
                >
                    <ContentSection>
                        <div slot="title">
                            <img
                                src={podcast.image}
                                alt={`${$_("title_image_of")} ${podcast.title}`}
                                class="podcast-image"
                            />
                        </div>
                        <div slot="content" class="headline-s podcast-title">
                            {podcast.title}
                        </div>
                    </ContentSection>
                </div>
                {#if index < podcasts.length - 1}
                    <div class="divider">
                        <div class="divider-h" />
                    </div>
                {/if}
            {/each}
        {:catch}
            <div class="error">
                <span class="text-l" style="font-size: 24px;">
                    {$_("entity_load_error")}
                </span>
            </div>
        {/await}
        <div />
    </div>
</GeneralLayout>

<style>
    .title {
        margin: 32px 16px;
    }

    .podcast-title {
        padding: 0px 32px 16px 0px;
    }

    .podcast-image {
        max-width: 420px;
        width: 100%;
    }

    .divider {
        padding: 24px 16px;
    }

    .content-wrapper {
        padding-bottom: 0px;
        padding: 0 16px;
    }

    @media (min-width: 1440px) {
        .title {
            font-size: 64px;
            margin-top: 10px;
        }

        .content-wrapper {
            padding-bottom: 16px;
            padding-top: 72px;
            padding-left: 24px;
        }

        .podcast-title {
            font-size: 40px;
            padding-right: 196px;
        }

        .podcast-image {
            max-width: 304px;
        }

        .divider {
            padding: 24px 48px 24px 16px;
        }
    }
</style>
